import cx from 'classnames'

/**
 * Utility function to generate dropdown styles.
 */
export const dropdownStyles = cx(
  // enter
  'data-enter:transition data-enter:ease-out data-enter:transform',
  // enterFrom
  "data-enterFrom:opacity-0 data-enterFrom:data-[anchor^='bottom']:-translate-y-1 data-enterFrom:data-[anchor^='top']:translate-y-1",
  // enterTo
  'data-enterTo:opacity-100 data-enterTo:translate-y-0',
)
